import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/multiple-language`; // Replace with your actual API URL

const customHeaders = {
  'Content-Type': 'application/json',
};

// Fetch all languages with pagination
export const fetchLanguagesTable = async (page: number, limit: number) => {
  const response = await axios.get(`${API_URL}/table?page=${page}&limit=${limit}`, { headers: customHeaders });
  return response.data;
};

// Fetch all languages
export const fetchLanguages = async () => {
  const response = await axios.get(API_URL, { headers: customHeaders });
  return response.data;
};

// Fetch a language by ID
export const fetchLanguageById = async (id: string) => {
  const response = await axios.get(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};

// Create a new language
export const addLanguage = async (newLanguage: { name: string; code: string; is_default: boolean; is_active: boolean; flag?: string }) => {
  const response = await axios.post(API_URL, newLanguage, { headers: {
    'Content-Type': 'multipart/form-data',
  } });
  return response.data;
};

// Edit an existing language
export const updateLanguage = async (id: string, updatedLanguage: { name: string; code: string; is_default: boolean; is_active: boolean; flag?: string }) => {
  const response = await axios.put(`${API_URL}/${id}`, updatedLanguage, { headers: {
    'Content-Type': 'multipart/form-data',
  } });
  return response.data;
};

// Delete a language
export const removeLanguage = async (id: string) => {
  const response = await axios.delete(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};
